module.exports = __webpack_public_path__ + "static/media/checkmark-grey-round.43ca8260.svg";